import React from "react";
import { useNavigate } from "react-router-dom";

const HAMBURGER = (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,.7)" strokeWidth="2" strokeLinecap="round">
    <line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/>
  </svg>
);

const CMD_ICON = (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <path d="M18 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3H6a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3V6a3 3 0 0 0 3-3 3 3 0 0 0-3-3 3 3 0 0 0-3 3v12a3 3 0 0 0 3 3"/>
  </svg>
);

const PLUS_ICON = (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
    <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
  </svg>
);

export default function HubTopbar({ stats, onHamburger, onOpenCmd }) {
  const nav = useNavigate();
  const { activeCount = 0, totalCount = 0, mrr = 0, overdueCount = 0, openTickets = 0, pendingAccounts = 0 } = stats || {};

  return (
    <>
      <style>{`
        #hub-topbar-bar { position:sticky;top:0;z-index:100;height:50px;background:#0b0f14;border-bottom:1px solid rgba(255,255,255,.07);display:flex;align-items:center;padding:0 20px;gap:12px; }
        .htb-stat { display:flex;align-items:center;gap:6px;padding:4px 12px;border-radius:100px;background:rgba(255,255,255,.06);font-size:12px;font-weight:600;color:rgba(255,255,255,.5);white-space:nowrap;transition:background .15s; }
        .htb-stat:hover { background:rgba(255,255,255,.1); }
        .htb-val { font-weight:800;color:white;font-variant-numeric:tabular-nums; }
        .htb-alert { background:rgba(220,38,38,.18) !important;color:rgba(252,165,165,.9) !important; }
        .htb-alert .htb-val { color:#fca5a5 !important; }
        .htb-divider { width:1px;height:20px;background:rgba(255,255,255,.08);flex-shrink:0; }
        .htb-btn { display:flex;align-items:center;gap:6px;padding:6px 14px;border-radius:8px;border:1px solid rgba(255,255,255,.12);background:rgba(255,255,255,.07);color:rgba(255,255,255,.75);font-size:12px;font-weight:600;cursor:pointer;transition:all .15s;white-space:nowrap;font-family:inherit; }
        .htb-btn:hover { background:rgba(255,255,255,.12);color:white; }
        .htb-primary { background:#1d4ed8 !important;border-color:#1d4ed8 !important;color:white !important; }
        .htb-primary:hover { background:#1e40af !important; }
        .htb-hamburger { display:none;background:none;border:none;cursor:pointer;padding:4px;align-items:center;justify-content:center; }
        @media(max-width:768px){ .htb-hamburger{display:flex} .htb-stats{display:none} .htb-actions{display:none} }
        .htb-stats { display:flex;align-items:center;gap:6px;flex:1;overflow:hidden; }
        .htb-logo-mobile { display:none;font-weight:800;font-size:14px;color:white; }
        @media(max-width:768px){ .htb-logo-mobile{display:block} }
      `}</style>

      <div id="hub-topbar-bar">
        {/* Hamburger (mobile only) */}
        <button className="htb-hamburger" onClick={onHamburger} aria-label="Meniu">
          {HAMBURGER}
        </button>

        {/* Logo mobile */}
        <span className="htb-logo-mobile">Orderly <span style={{ color:"#3b82f6" }}>Hub</span></span>

        {/* Live stats */}
        <div className="htb-stats">
          <div className="htb-stat">
            <span className="htb-val">{activeCount}</span> active <span style={{ opacity:.5 }}>/ {totalCount}</span>
          </div>
          <div className="htb-stat">
            MRR <span className="htb-val">€{Math.round(mrr).toLocaleString("ro-RO")}</span>
          </div>
          {overdueCount > 0 && (
            <div className="htb-stat htb-alert">
              <span className="htb-val">{overdueCount}</span> restanțe
            </div>
          )}
          {openTickets > 0 && (
            <div className="htb-stat">
              <span className="htb-val">{openTickets}</span> tickete deschise
            </div>
          )}
          {pendingAccounts > 0 && (
            <div className="htb-stat">
              <span className="htb-val">{pendingAccounts}</span> conturi în așteptare
            </div>
          )}
        </div>

        {/* Actions */}
        <div className="htb-actions" style={{ display:"flex",alignItems:"center",gap:8,marginLeft:"auto" }}>
          <button className="htb-btn" onClick={onOpenCmd}>
            {CMD_ICON} Caută <kbd style={{ fontSize:10,opacity:.5,background:"rgba(255,255,255,.1)",padding:"1px 5px",borderRadius:4,fontFamily:"monospace" }}>⌘K</kbd>
          </button>
          <button className="htb-btn htb-primary" onClick={() => nav("/restaurants/new")}>
            {PLUS_ICON} Restaurant nou
          </button>
        </div>
      </div>
    </>
  );
}
